


































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import App from "../App.vue";
import { ChangeLogEntryData } from "../models/ChangeLogEntryData";
import ErrorDialog from "./ErrorDialog.vue";
import { EnumHelpers, LogType } from "../helpers/EnumHelpers";
import { FailureResponseData } from "../models/FailureResponseData";
import ValidationErrorsCard from "./ValidationErrorsCard.vue";
import TitleCard from "./TitleCard.vue";
import ActionsCard from "./ActionsCard.vue";
import axios from "axios";
import { ToolDataList } from "../models/ToolDataList";
import { ToolData } from "../models/ToolData";

@Component({
  components: { ErrorDialog, ValidationErrorsCard, TitleCard, ActionsCard },
})
export default class ChangeLogEntryDialog extends App {
  private get getTitle() {
    if (this.isValidEdit()) {
      return "Edit Change Log Entry";
    } else {
      return "Create New Change Log Entry";
    }
  }

  @Prop({ default: false })
  public isShown!: boolean;
  @Prop({ default: false })
  public isEdit!: boolean;
  @Prop({ required: false })
  public item!: ChangeLogEntryData;

  private privateIsShown: boolean = false;
  private errorDialogIsShown: boolean = false;
  private failure: FailureResponseData = new FailureResponseData();

  private types: Array<string> = EnumHelpers.GetLogTypes();
  private tools: Array<ToolData> = [];

  private type: string = "Other";
  private description: string = "";
  private selectedTool: object = "";

  @Watch("item")
  public onItemPropertyChanged(value: ChangeLogEntryData) {
    if (value !== null) {
      this.selectedTool = this.$store.state.productVersionTools.find(
        (t) => t.name === value.toolName
      );
    }
  }
  @Watch("isShown")
  public onIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    this.privateIsShown = value;
  }

  @Watch("privateIsShown")
  public onprivateIsShownPropertyChanged(value: boolean, oldvalue: boolean) {
    if (value) {
      this.setDefaultData();
      if (this.isValidEdit()) {
        this.type = EnumHelpers.GetLogType(this.item.type, false);
        this.description = this.item.description;
      }
    } else {
      this.$emit("dialogClosed");
      this.loading = false;
    }
  }

  public async commitChanges() {
    if (!this.checkForm()) {
      return;
    }

    this.loading = true;

    try {
      const res: ChangeLogEntryData = new ChangeLogEntryData(
        EnumHelpers.GetLogTypeValue(this.type),
        this.description,
        this.selectedTool.id,
        this.selectedTool.name
      );

      const errorObject: Object = "";
      const errorsOccurred: boolean = false;

      if (this.isValidEdit()) {
        this.$emit("editChangeLogEntry", this.item, res);
      } else {
        this.$emit("addChangeLogEntry", res);
      }
      this.privateIsShown = false;
    } catch (e) {
      this.failure = new FailureResponseData(e.message);
      this.errorDialogIsShown = true;
    }

    this.loading = false;
    this.selectedTool = {};
  }

  public cancelled(item) {
    this.privateIsShown = false;
    this.$emit("dialogCancelled");
  }

  private setDefaultData() {
    this.validationErrors = [];
    this.type = "Other";
    this.description = "";

    this.resetValidation();
  }

  private isValidEdit() {
    return this.isEdit && this.item !== undefined;
  }

  private checkForm() {
    this.validationErrors = [];

    const form: any = this.$refs.form;
    if (form) {
      return form.validate();
    } else {
      if (!this.type) {
        this.validationErrors.push("Log type is required.");
      }
      if (!this.description) {
        this.validationErrors.push("Log description is required.");
      }
    }

    return this.validationErrors.length === 0;
  }

  private async created() {}
}
